import React from 'react';
import { ArrowClockwise } from '@phosphor-icons/react';
import { Button, Tooltip, TooltipTrigger } from '@chatsdet/ui';

import { getRerunButtonState, type TestRunRerunAvailability } from './rerunAvailability';

type RerunTestButtonProps = {
  availability: TestRunRerunAvailability;
  isPending: boolean;
  onPress: () => void;
  iconOnly?: boolean;
};

export const RerunTestButton: React.FC<RerunTestButtonProps> = ({
  availability,
  isPending,
  onPress,
  iconOnly = false,
}) => {
  const state = getRerunButtonState(availability, isPending);
  const button = iconOnly ? (
    <Button
      variant="icon"
      size="sm"
      iconOnly
      tooltip={state.tooltip}
      aria-label="Rerun test"
      isDisabled={state.isDisabled}
      onPress={onPress}
    >
      <ArrowClockwise size={16} />
    </Button>
  ) : (
    <Button
      variant="ghost"
      size="sm"
      aria-label="Rerun test"
      isDisabled={state.isDisabled}
      onPress={onPress}
      iconLeft={<ArrowClockwise size={14} />}
    >
      Rerun
    </Button>
  );

  // Icon buttons already own their tooltip while enabled. The wrapper below
  // is only needed when the native-disabled button cannot receive hover events.
  if (iconOnly && !state.isDisabled) {
    return button;
  }

  // A native-disabled button does not receive hover events. Put the tooltip
  // trigger on a wrapper so the disabled reason remains discoverable.
  return (
    <TooltipTrigger delay={0}>
      <span className="inline-flex">{button}</span>
      <Tooltip>{state.tooltip}</Tooltip>
    </TooltipTrigger>
  );
};
